import ProtectedFilesBadge from './ProtectedFilesBadge.component';

export default ProtectedFilesBadge;